import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderForComponentsService } from './loaderForComponents.service';
@Component({
    selector: 'app-loader-components',
    templateUrl: './loaderForComponents.component.html',
    styleUrls: ['./loaderForComponents.component.css'],
    standalone: false
})
export class LoaderCustomForComponent {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  isLoading: Subject<boolean> = this.loaderForComponentsService.isLoading;
  constructor(private loaderForComponentsService: LoaderForComponentsService) { }
}